import { BasicDatatable } from "../../../containers/table/basic_datatable";
import { useBasicTableSearchBox } from "../../../containers/table/useBasicTableSearchBox.hook";
import { useModalPdf } from "./modal.hook";
import IconButton from '@mui/material/IconButton';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Grid, Modal } from "@mui/material";
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

export default function Table({ hook }){

    const searchBox = useBasicTableSearchBox();
    const modalPdf = useModalPdf();
    
    const columns = [
        {
        title: 'Remisión',
        dataIndex: 'id',
        key: 'id',
        width: '30%',
        ...searchBox.getColumnSearchProps('id'),
        },
        {
          title: 'Fecha',
          dataIndex: 'date',
          key: 'date',
          width: '30%',
          render: (text, param, index) => {
            let date = new Date(param.date);
            date.setHours(date.getHours() - 6);
            return <span key={`date_${index}`}>{date.toISOString().split('T')[0]}</span>
          },
        },
        {
          title: 'Cliente',
          dataIndex: 'client',
          key: 'client',
          width: '30%',
          render: (text, param, index) => {
            return <span key={`client_${index}`}>{param.remissionDetails.length > 0 ? param.remissionDetails[0].orderDetail?.productPrice?.client?.name : 'Sin Cliente'}</span>
          },
        },
        {
          title: '',
          dataIndex: 'uuid',
          key: 'uuid',
          width: '30%',
          render: (text, param, index) => {
            return <span key={`pdf_${index}`}>{
              <IconButton
                style={{ marginRight: '10px' }}
                color='primary'
                aria-label='pdf'
                onClick={() => {
                  modalPdf.downloadPdf(param.uuid);
                }}
              >
                <PictureAsPdfIcon />
              </IconButton>
            }</span>
          },
        }
    ];
    return(
      <div style={{ width: '100%' }}>
        <Modal
          open={modalPdf.open}
          onClose={modalPdf.hanldeClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
              {
                !modalPdf.bytes ? <>Cargando...</> :
                  <div>
                    <object width="100%" height="600px"
                      data={`data:application/pdf;base64,${modalPdf.bytes}`}
                      type="application/pdf" className="internal"
                    >
                      <embed
                        src={`data:application/pdf;base64,${modalPdf.bytes}`}
                        type="application/pdf"
                      />
                    </object>
                  </div>
              }
              </Grid>
            </Grid>
          </Box>
        </Modal>
        <BasicDatatable columns={columns} data={hook.data} pagination={true} />
      </div>
    );
}